// instrumentInfo.js
export const instrumentInfo = {
  // "BTC/USD": {
  //   contractSize: 1,
  //   pipSize: 0.1,
  //   currRate: 42139,
  //   isCrossPair: false,
  //   baseCurrency: "USD",
  // },
  "XAU/USD": {
    contractSize: 100,
    pipSize: 0.1,
    currRate: 2018.59,
    isCrossPair: false,
    baseCurrency: "USD",
  },
  // "EUR/USD": {
  //   contractSize: 100000,
  //   pipSize: 0.0001,
  //   currRate: 1.0805,
  //   isCrossPair: false,
  //   baseCurrency: "USD",
  // },
  // "USD/JPY": {
  //   contractSize: 100000,
  //   pipSize: 0.01,
  //   currRate: 148.375,
  //   isCrossPair: false,
  //   baseCurrency: "JPY",
  // },
  // US30: {
  //   contractSize: 1,
  //   pipSize: 0.1,
  //   currRate: 34305,
  //   isCrossPair: false,
  //   baseCurrency: "USD",
  // },
  // "AUD/CAD": {
  //   contractSize: 100000,
  //   pipSize: 0.0001,
  //   currRate: 0.8847,
  //   isCrossPair: true,
  //   baseCurrency: "CAD",
  // },
};

export const AccountExchangePairs = {
  "EUR/USD": {
    exchangeRate: 1.0805,
  },
  "EUR/CAD": {
    exchangeRate: 1.4546,
  },
  "EUR/JPY": {
    exchangeRate: 148.13,
  },
  "EUR/GPB": {
    exchangeRate: 148.13,
  },
  "USD/JPY": {
    exchangeRate: 147.99,
  },
  "USD/CAD": {
    exchangeRate: 148.13,
  },
  "GBP/USD": {
    exchangeRate: 148.13,
  },
  "GBP/CAD": {
    exchangeRate: 148.13,
  },
  "GBP/JPY": {
    exchangeRate: 148.13,
  },

  // Add more pairs as needed
};
